

exports.__esModule = true;

var _squid = require('squid');

var _angular = require('angular');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('xo-ui-components/src/directionality/directive');

require('components/xo-ui-components/src/error-tooltip/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('xoPasswordInput', {
    tag: 'xo-password-input',
    template: _template2['default'],
    props: {
        user: {
            type: 'var',
            required: true
        },
        singlePassword: {
            type: 'var',
            required: false
        },
        isDisabled: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.locale = _squid.$locale;
            this.passwordToolTip = 'show';
            this.passwordMismatch = 'hide';
            this.requirementLength = 'active';
            this.requirementNumberSymbol = 'active';

            /*
                The next 2 methods serve to allow passwordValidate & confirmPasswordValidate directives
                to access + change the scope variables inside here as the scopes
                in these directives are different and do not inherit from here.
            */
            this.setScopeProp = function (prop, newVal) {
                _this[prop] = newVal;
            };

            this.getScopeProp = function (prop) {
                return _this[prop];
            };

            /*
             * single password case
             * flags and functions to enable single password hide and
             * show password feature
             */
            var enableSinglePassword = function enableSinglePassword() {
                _this.showRawPassword = false;
                _this.showPasswordTextToggleLink = false;

                _this.toggleShowRawPassword = function ($event) {
                    var $passwordEl = (0, _jquery2['default'])('#password');
                    var valLength = $passwordEl.val().length;

                    $event.preventDefault();
                    _this.showRawPassword = !_this.showRawPassword;

                    if (_this.showRawPassword) {
                        $passwordEl.prop('type', 'text');
                    } else {
                        $passwordEl.prop('type', 'password');
                    }

                    // timeout is need to get this function running after
                    // the onPasswordBlur function
                    (0, _angular.$timeout)(function () {
                        $passwordEl.focus();
                        // firefox set the cursor to the end of the value text
                        $passwordEl.get(0).setSelectionRange(valLength, valLength);
                    });
                };
            };

            // enable singlepassword if this.singlePassword is set to true
            this.$watch('singlePassword', function (newVal, oldVal) {
                if (newVal) {
                    enableSinglePassword();
                }
            });
        }
    },
    actions: {
        // 'singlePassword' case - show the 'hide/show' password link
        onPasswordFocusBlur: function onPasswordFocusBlur($event, focused) {
            var passwordValLength = this.user.password && this.user.password.length;
            if (this.singlePassword) {
                if (focused) {
                    this.showPasswordTextToggleLink = true;
                } else {
                    // if length is zero then it is false
                    this.showPasswordTextToggleLink = passwordValLength ? true : false;
                }
            }
        }
    }
});


(0, _angular.$registerDirective)('password-validate', function () {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function link(scope, elem, attrs, controller) {
            var ngModel = controller;
            var passwordInputScope = scope.componentScope;

            ngModel.$setValidity('password', false);

            var fourSequence = function fourSequence(value) {
                value += ' ' + value.split('').reverse().join('');
                var sequences = '`1231234234534564567567867897890890-90-= ' + // row 1
                'qwerwertertyrtyutyuiyuiouiopiop[op[]p[]\\ ' + // row 2
                'asdfsdfgdfghfghjghjkhjkljkl;kl;\' ' + // row 3
                'zxcvxcvbcvbnvbnmbnm,nm,.m,./ ' + // row 4
                '~!@#!@#$@#$%#$%^$%^&%^&*^&*(&*()*()_()_+ ' + // shift + row 1
                'QWERWERTERTYRTYUTYUIYUIOUIOPIOP{OP{}P{}| ' + // shift + row 2
                'ASDFSDFGDFGHFGHJGHJKHJKLJKL:KL:" ' + // shift + row 3
                'ZXCVXCVBCVBNVBNMBNM<NM<>M<>?'; // shift + row 4

                var len = value.length;
                for (var i = 0; i < len - 3; i++) {
                    if (sequences.indexOf(value.substr(i, 4)) > -1) {
                        return false;
                    }
                }
                return true;
            };

            ngModel.$parsers.unshift(function (viewValue) {
                passwordInputScope.setScopeProp('requirementLength', viewValue.length >= 8 && viewValue.length <= 20 ? false : 'active');
                passwordInputScope.setScopeProp('requirementNumberSymbol', /\d/.test(viewValue) || /[\-!@#$%\^&*()_+|~=`{}\[\]:';'<>?,.\/\\]/.test(viewValue) ? false : 'active');

                passwordInputScope.setScopeProp('requirementInfoSec', false);
                if (scope.user.country === 'AU') {
                    var lcViewVal = viewValue.toLowerCase();
                    var firstName = scope.user && scope.user.first_name && scope.user.first_name.toLowerCase();
                    var lastName = scope.user && scope.user.last_name && scope.user.last_name.toLowerCase();
                    var dob = scope.user && scope.user.dob_day + '/' + scope.user.dob_month + '/' + scope.user.dob_year;
                    if (lcViewVal.indexOf(firstName) !== -1 || lcViewVal.indexOf(lastName) !== -1 || lcViewVal.indexOf(dob) !== -1) {
                        passwordInputScope.setScopeProp('requirementInfoSec', 'active');
                    }
                }

                passwordInputScope.setScopeProp('restrictionEmail', false);
                passwordInputScope.setScopeProp('restrictionFourRepeated', viewValue.length > 3 && /(.)\1{3}/.test(viewValue) ? 'active' : false);
                passwordInputScope.setScopeProp('restrictionNonValidCharacters', /[\x00-\x08\x0E-\x1F\x80-\xFF ]/.test(viewValue) ? 'active' : false);
                passwordInputScope.setScopeProp('restrictionFourSequence', viewValue.length > 3 && !fourSequence(viewValue) ? 'active' : false);

                var requirements = !(passwordInputScope.getScopeProp('requirementLength') || passwordInputScope.getScopeProp('requirementNumberSymbol') || passwordInputScope.getScopeProp('requirementInfoSec'));
                var restrictions = !(passwordInputScope.getScopeProp('restrictionEmail') || passwordInputScope.getScopeProp('restrictionFourRepeated') || passwordInputScope.getScopeProp('restrictionNonValidCharacters') || passwordInputScope.getScopeProp('restrictionFourSequence'));

                ngModel.$setValidity('password', requirements && restrictions);
                passwordInputScope.setScopeProp('passwordToolTip', requirements && restrictions ? 'hide' : 'show');
                return viewValue;
            });
        }
    };
});

(0, _angular.$registerDirective)('confirm-password-validate', function () {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function link(scope, elem, attrs, controller) {
            var ngModel = controller;
            var passwordInputScope = scope.componentScope;

            ngModel.$setValidity('confirmPassword', false);

            passwordInputScope.$watch('user.password', function (newValue) {
                var cPass = passwordInputScope.user.confirmPassword;
                if (cPass && cPass.length && cPass !== newValue) {
                    ngModel.$setValidity('confirmPassword', false);
                    passwordInputScope.setScopeProp('passwordMismatch', 'show');
                }
            });

            ngModel.$parsers.unshift(function (viewValue) {
                var passwordVal = passwordInputScope.user.password;

                passwordInputScope.setScopeProp('restrictionMatch', passwordVal && viewValue.length > 0 && passwordVal.indexOf(viewValue) === 0 && passwordVal === viewValue);

                ngModel.$setValidity('confirmPassword', passwordVal === viewValue);

                passwordInputScope.setScopeProp('passwordMismatch', passwordInputScope.getScopeProp('restrictionMatch') ? 'hide' : 'show');
                return viewValue;
            });
        }
    };
});

_squid.$Component;

_squid.$locale;

_angular.$timeout;

_angular.$registerDirective;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/passwordInput/directive.js
// module id = ./components/xo-guest-components/src/guest/passwordInput/directive.js
// module chunks = 1